import { Toast } from 'vant'
export default {
	showLoading(message, duration = 1000) {
		Toast.loading({
			duration,
			forbidClick: true,
			message,
		})
	},
	clearLoading() {
		let timer = setTimeout(() => {
			Toast.clear()
			clearTimeout(timer)
		}, 2000)
	},
}
